import React from "react";
import Modal from "react-bootstrap/Modal";
class NhapDsKhachhang extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text1: "",
    };
  }
  onChangeData = (field, event) => {
    let state = this.state;
    state[field] = event.target.value;
    this.setState(state);
  };
  onHide = () => {
    let props = this.props;
    props.onHide();
  };

  render() {
    let props = this.props;
    return (
      <Modal
        {...props}
        size="modal-dialog"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="mdi mdi-download"></i>
            </span>
            Nhập danh sách KH từ file Excel
          </h4>
          <button
            type="button"
            className="close-popup-new"
            data-dismiss="modal"
            aria-label="Close"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>

        <Modal.Body className="">
          <form className="form  ">
            <div className="form-body">
              <div className="col-md-12">
                <div className="form-group row">
                  <label
                    className="col-md-5 label-control text-left"
                    for="userinput2"
                  >
                    Chọn danh sách khách hàng
                  </label>
                  <div className="col-md-7">
                    <label id="projectinput8" className="file center-block">
                      <input type="file" id="file" />
                      <span className="file-custom"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button type="submit" className="btn btn-new-main btn-checknew">
            <span className="btn-icon-left">
              <i class="mdi mdi-download"></i>
            </span>{" "}
            Lấy thông tin từ file vào hệ thống
          </button>
          <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={this.onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>
            Đóng
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default NhapDsKhachhang;
